module.exports = __webpack_public_path__ + "static/media/24food-logo.d867269e.png";